import React from 'react';
import styled from 'styled-components/macro';

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  margin-bottom: 15px;
`;

function IconUploadType() {
  return (
    <IconWrapper>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 2C0 .895.89 0 2 0h32c1.105 0 2 .89 2 2v32c0 1.105-.89 2-2 2H2c-1.105 0-2-.89-2-2V2zm2.483.483h31.034v31.034H2.483V2.483zM16.4 12h-4.8c-.88 0-1.592.73-1.592 1.625L10 23.375c0 .894.72 1.625 1.6 1.625h12.8c.88 0 1.6-.73 1.6-1.625V15.25c0-.894-.72-1.625-1.6-1.625H18L16.4 12z" fill="#CBCBCB" fillRule="evenodd" />
      </svg>
    </IconWrapper>
  );
}

export default IconUploadType;
